import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ServiceCategoryProps } from '../../components/Autocomplete/ServiceCategories/model';
import type { RootState } from '../../store';

interface Props {
  categories: ServiceCategoryProps[];
}
// Define the initial state using that type
const initialState: Props = { categories: [] };

export const serviceCategoriesSlice = createSlice({
  name: 'serviceCategories',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setService: (state, action: PayloadAction<ServiceCategoryProps[]>) => {
      state.categories = action.payload;
    },
  },
});

export const { setService } = serviceCategoriesSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectServiceCategories = (state: RootState) => state.serviceCategories.categories;
export default serviceCategoriesSlice.reducer;
